import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {CasinoGame, CasinoGameSeoEditor, GameLockedField, ListCasinoGameResponse, SaveCasinoGameSeoRequest, SeoMetadata} from "../http/protocol";


export class CasinoGameService  extends AbstractAdminEntityService<CasinoGame, ListCasinoGameResponse>  {

    constructor(http : HttpService) {
        super("/casino-game", http)
    }

    getLockedFields(gameId: number): Promise<GameLockedField[]> {
        return this.http.get(`${this.entityPath}/${gameId}/locked-fields`);
    }

    setFieldLock(gameId: number, field: GameLockedField, locked: boolean): Promise<GameLockedField[]> {
        return this.http.put(`${this.entityPath}/${gameId}/locked-fields/${field}/${locked}`, {})        
    }

    /** The game's stored SEO per locale, plus the values derived from the game that empty fields fall back to. */
    getSeo(gameId: number): Promise<CasinoGameSeoEditor> {
        return this.http.get(`${this.entityPath}/${gameId}/seo`);
    }

    /**
     * Stores the sent locales and returns every stored entry; a rejected save answers 400 with the reason as a
     * plain-text body.
     */
    saveSeo(gameId: number, request: SaveCasinoGameSeoRequest): Promise<SeoMetadata[]> {
        return this.http.put(`${this.entityPath}/${gameId}/seo`, request);
    }


}
